import React from "react";
import Sidebar from "@/components/Sidebar";
import BottomNav from "@/components/BottomNav";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import TrialBanner from "@/components/TrialBanner";
import Header from "@/components/Header";
import OnboardingHost from "@/components/OnboardingHost";

/**
 * v1.2 — AppShell with persistent top-right Header cluster.
 * - 240px left sidebar (operational items, role-gated, sticky Settings).
 * - 56px top header (BuildChip super_admin · Help · Bell · Settings · Avatar).
 * - 16px BottomNav on mobile with More drawer.
 * - Phase B4 — OnboardingHost mounted globally: owns the Shepherd tour
 *   trigger logic and renders the persistent Go-live checklist widget.
 */
export default function AppShell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface dark:bg-navy-900 text-navy-900 dark:text-navy-50" data-testid="app-shell">
      <ImpersonationBanner />
      <div className="flex flex-1">
        <Sidebar />
        <div className="flex-1 min-w-0 flex flex-col">
          <Header context="org" />
          <main
            className="flex-1 pb-24 md:pb-10 px-4 md:px-8 lg:px-10 py-6 md:py-8 max-w-[1500px] w-full"
            data-testid="app-main"
          >
            <TrialBanner />
            {children}
          </main>
        </div>
      </div>
      <BottomNav />
      <OnboardingHost />
    </div>
  );
}
